import { MagnifyingGlass } from "react-loader-spinner";
import { useSelector } from "react-redux";
import { useGetCompletedTodosQuery } from "../features/api/apiSlice";
import CompletedTodo from "./CompletedTodo";
import NoDataFound from "./NoDataFound";

export default function CompletedTodoList() {
    const { completeFilter: colors } = useSelector((state) => state.filter);
    const { data: completedTodos = [], isLoading } = useGetCompletedTodosQuery(colors);

    return (
        <div className="mt-2 text-gray-700 text-sm max-h-[300px] overflow-y-auto">

            {isLoading ? <div className="flex justify-center align-center">
                <MagnifyingGlass
                    visible={true}
                    height="150"
                    width="150"
                    ariaLabel="MagnifyingGlass-loading"
                    wrapperStyle={{}}
                    wrapperClass="MagnifyingGlass-wrapper"
                    glassColor='#c0efff'
                    color='#e15b64'
                />
            </div>
                :
                completedTodos.length > 0 ?
                    completedTodos.map((todo) => (
                        <CompletedTodo todo={todo} key={todo.id} />
                    )) : <NoDataFound />}

        </div>
    );
}
